// DTOs + enums for the user-operations feature.
// Ported from ops-portal/src/app/model/... and ops-portal/src/app/model/enum/...

export enum UserOperationTypeEnum {
  ALL = 'All',
  ADD_FUNDS = 'Add Funds',
  WITHDRAW_FUNDS = 'Withdraw Funds',
  ADDRESS_BOOK_TRANSFER = 'Bank Transfer',
  WITHDRAW_REVENUE = 'Withdraw Revenue',
}

export enum OperationsStatusEnum {
  ALL = 'ALL',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PROCESSED = 'PROCESSED',
}

// PaymentIntermediariesStatusEnum / PaymentIntermediary now sourced from
// '@/types/payment-intermediary' (canonical).
import type { PaymentIntermediary } from './payment-intermediary';
export { PaymentIntermediaryStatusFilter as PaymentIntermediariesStatusEnum } from './payment-intermediary';

export interface GetUserOperationsRecordsRequest {
  type: string;
  status?: string;
  startDate: string;
  endDate: string;
}

export interface ConfirmUserOperationRequest {
  recordId: string;
  uuid: string;
  idPaymentIntermediary: string | null;
  amountPaid: number | null;
  externalReference: string;
  notes: string;
  operationType: string;
}

/** @deprecated Use `PaymentIntermediary` from '@/types/payment-intermediary' instead. */
export type PaymentIntermediariesRecord = PaymentIntermediary;

export interface AddWithdrawFundsRecord {
  id: string;
  uuid: string;
  date: number;
  status: string;
  statusDescription: string;
  orderType: string;
  orderTypeDescription: string;
  businessEntityId?: string;
  userId?: string;
  businessEntityName: string;
  userName: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  amountRequested: number;
  amountToPay?: number;
  processingFee: number;
  paymentMethod?: string;
  paymentMethodDescription?: string;
  attachmentUrl?: string[];
  // paymentIntermediary varies: object with {name,accountNumber} in view, array-like in confirm setup
  paymentIntermediary?: { id?: number | string; name?: string; accountNumber?: string } | string[] | null;
  paymentAccountNumber?: string;
  amountPaid?: number;
  externalPaymentReference?: string;
  dioolTrackingId?: string;
  notes?: string;
  remark?: string;
  businessName?: string;
  contactType?: string;
}

export interface StatsAddFundsResponse {
  pending: number;
  canceled: number;
  processed: number;
  total: number;
}

export interface StatsAddWithdrawFundsResponse {
  addFunds: StatsAddFundsResponse;
  withdrawFunds: StatsAddFundsResponse;
  bankTransfer: StatsAddFundsResponse;
  withdrawRevenue: StatsAddFundsResponse;
}
